export default __webpack_public_path__ + "static/media/Tent_Move_3sm.c7739287.gif";